












































import { Vue, Component } from "vue-property-decorator";

@Component({
  name: "LegalNotice"
})
export default class LegalNotice extends Vue {}
